import { Observable } from 'rxjs';
import {
  Template,
  TemplateVersionDetail,
  TemplateVersion,
  SaveVersionRequest,
  CopyTemplateRequest
} from '@model/templates';

export interface ExamCatalogItem {
  id: string;
  name: string;
}

/**
 * Abstract repository for Template and Version operations.
 */
export abstract class TemplateRepository {

  abstract getExamCatalog(): Observable<ExamCatalogItem[]>;

  abstract searchExams(name: string): Observable<ExamCatalogItem[]>;

  abstract findAll(examId?: string, resultTypeId?: string, active?: boolean): Observable<Template[]>;

  abstract findById(id: string): Observable<Template>;

  abstract create(template: Partial<Template>): Observable<Template>;

  abstract update(id: string, template: Partial<Template>): Observable<Template>;

  abstract deactivate(id: string): Observable<void>;

  abstract copy(id: string, request: CopyTemplateRequest): Observable<Template>;

  abstract getVersion(templateId: string, versionId: string): Observable<TemplateVersionDetail>;

  abstract getVersions(templateId: string): Observable<TemplateVersion[]>;

  abstract saveVersion(templateId: string, versionId: string, request: SaveVersionRequest): Observable<TemplateVersionDetail>;

  abstract publishVersion(templateId: string, versionId: string): Observable<TemplateVersionDetail>;

  abstract createVersion(templateId: string): Observable<TemplateVersionDetail>;
}
